<template>
  <div class="float-container">
    <!-- 公众号图标 -->
    <div
        v-if="this.homeData.weChatImage"
        class="float-item wechat-item"
        :class="{ 'fixed-position': isFixed, 'expanded': wechatExpanded }"
        @mouseenter="handleWechatMouseEnter"
        @mouseleave="handleWechatMouseLeave"
    >
      <div class="item-icon-wrapper">
        <div class="item-icon wechat-icon">
          <el-image :src="require('@/assets/images/icon_wechat.png')" fit="contain" />
        </div>
        <span class="item-text">公众号</span>
      </div>

      <!-- 公众号二维码展开区域 -->
      <transition name="qrcode-fade">
        <div v-if="wechatExpanded" class="qrcode-expand">
          <div class="qrcode-container">
            <div class="qrcode-header">
              <h3>关注公众号</h3>
            </div>
            <div class="qrcode-image">
              <!-- 这里可以替换为真实的二维码图片 -->
              <div class="qrcode-placeholder">
                <div class="qrcode-demo">
                  <el-image :src="this.homeData.weChatImage" fit="contain" />
<!--                  <div class="qrcode-pattern">-->
<!--                    <div class="qrcode-corner top-left"></div>-->
<!--                    <div class="qrcode-corner top-right"></div>-->
<!--                    <div class="qrcode-corner bottom-left"></div>-->
<!--                    <div class="qrcode-dots">-->
<!--                      <div v-for="i in 25" :key="i" class="qrcode-dot"></div>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
              </div>
              <p class="qrcode-tip">微信扫一扫关注</p>
            </div>
          </div>
          <!-- 三角形指示箭头 -->
          <div class="arrow"></div>
        </div>
      </transition>
    </div>

    <!-- 天猫店图标 -->
    <div
        v-if="this.homeData.tmallUrl"
        class="float-item tmall-item"
        :class="{ 'fixed-position': isFixed }"
        @click="goToTmall"
    >
      <div class="item-icon-wrapper">
        <div class="item-icon tmall-icon">
          <el-image :src="require('@/assets/images/icon_tmall.png')" fit="contain" />
        </div>
        <span class="item-text">天猫店</span>
      </div>
    </div>

    <!-- 京东店图标 -->
    <div
        v-if="this.homeData.jdUrl"
        class="float-item jd-item"
        :class="{ 'fixed-position': isFixed }"
        @click="goToJD"
    >
      <div class="item-icon-wrapper">
        <div class="item-icon jd-icon">
          <el-image :src="require('@/assets/images/icon_jd.png')" fit="contain" />
        </div>
        <span class="item-text">京东店</span>
      </div>
    </div>
  </div>
</template>

<script>
import {getFooterData} from "@/api";

export default {
    name: 'Fix',
    data() {
        return {
          homeData: {},

          wechatExpanded: false,
          isFixed: true,
          scrollThreshold: 100, // 滚动多少像素后变为固定定位
        };
    },
    mounted() {
      this.fetchHomeData();

      // 监听滚动事件
      window.addEventListener('scroll', this.handleScroll);
      this.handleScroll(); // 初始化检查位置
    },
    beforeDestroy() {
      // 组件销毁前移除事件监听
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      async fetchHomeData() {
        try {
          this.isLogin = !!localStorage.getItem("token");
          const response = await getFooterData();
          if (response && response.data && response.data.length > 0) {
            this.homeData = response.data[0];
          }
        } catch (error) {
          console.error('获取数据失败:', error);
        }
      },
      handleWechatMouseEnter() {
        this.wechatExpanded = true;
      },
      handleWechatMouseLeave() {
        this.wechatExpanded = false;
      },
      handleScroll() {
        // 根据滚动位置决定是否使用固定定位
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.isFixed = scrollTop > this.scrollThreshold;
      },
      goToTmall() {
        // 跳转到天猫店铺
        window.open(this.homeData.tmallUrl || 'https://www.tmall.com', '_blank');
      },
      goToJD() {
        // 跳转到京东店铺
        window.open(this.homeData.jdUrl || 'https://www.jd.com', '_blank');
      }
    },
};
</script>

<style lang="scss" scoped>
.float-container {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  transition: all 0.3s ease;
}

.float-item {
  margin-bottom: 10px;
  transition: all 0.3s ease;
  position: relative;
}

.float-item.fixed-position {
  position: relative;
}

.item-icon-wrapper {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  border-radius: 25px 0 0 25px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.float-item:hover .item-icon-wrapper {
  padding-right: 20px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

/* 公众号样式 */
.wechat-item .item-icon-wrapper {
  background-color: #07c160; /* 微信绿色 */
  color: white;
}

.wechat-item:hover .item-icon-wrapper {
  background-color: #06ad56;
}

/* 天猫样式 */
.tmall-item .item-icon-wrapper {
  background-color: #ff5000; /* 天猫红色 */
  color: white;
}

.tmall-item:hover .item-icon-wrapper {
  background-color: #e64700;
}

/* 京东样式 */
.jd-item .item-icon-wrapper {
  background-color: #e31436; /* 京东红色 */
  color: white;
}

.jd-item:hover .item-icon-wrapper {
  background-color: #c1122e;
}

.item-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.icon-svg {
  width: 100%;
  height: 100%;
}

.item-text {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

/* 公众号二维码展开区域样式 */
.qrcode-expand {
  position: absolute;
  right: 80px;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  width: 220px;
  z-index: 10000;
  animation: float 3s ease-in-out infinite;
}

.arrow {
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid white;
}

.qrcode-container {
  padding: 20px;
  text-align: center;
}

.qrcode-header h3 {
  margin: 0 0 5px 0;
  color: #333;
  font-size: 16px;
}

.qrcode-header p {
  margin: 0;
  color: #666;
  font-size: 12px;
}

.qrcode-image {
  margin: 15px 0;
}

.qrcode-placeholder {
  width: 150px;
  height: 150px;
  margin: 0 auto;
  background-color: #f5f5f5;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eee;
}

.qrcode-demo {
  width: 130px;
  height: 130px;
  background-color: white;
  position: relative;
  overflow: hidden;
}

.qrcode-pattern {
  position: relative;
  width: 100%;
  height: 100%;
}

.qrcode-corner {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 3px solid #000;
}

.qrcode-corner.top-left {
  top: 10px;
  left: 10px;
  border-right: none;
  border-bottom: none;
}

.qrcode-corner.top-right {
  top: 10px;
  right: 10px;
  border-left: none;
  border-bottom: none;
}

.qrcode-corner.bottom-left {
  bottom: 10px;
  left: 10px;
  border-right: none;
  border-top: none;
}

.qrcode-dots {
  position: absolute;
  top: 40px;
  left: 40px;
  width: 50px;
  height: 50px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 3px;
}

.qrcode-dot {
  background-color: #000;
  border-radius: 1px;
}

.qrcode-dot:nth-child(3n) {
  background-color: transparent;
}

.qrcode-tip {
  margin: 10px 0 0 0;
  font-size: 12px;
  color: #888;
}

.qrcode-footer {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #eee;
}

.qrcode-footer p {
  margin: 0;
  font-size: 11px;
  color: #999;
}

/* 过渡动画 */
.qrcode-fade-enter-active,
.qrcode-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.qrcode-fade-enter,
.qrcode-fade-leave-to {
  opacity: 0;
  transform: translateY(-50%) translateX(10px);
}

/* 浮动动画 */
@keyframes float {
  0%, 100% {
    transform: translateY(-50%);
  }
  50% {
    transform: translateY(-52%);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .float-container {
    right: 0;
  }

  .item-icon-wrapper {
    padding: 10px 12px;
  }

  .item-text {
    font-size: 12px;
  }

  .qrcode-expand {
    width: 180px;
    right: 70px;
  }

  .qrcode-placeholder {
    width: 120px;
    height: 120px;
  }

  .qrcode-demo {
    width: 100px;
    height: 100px;
  }

  .float-item:hover .item-icon-wrapper {
    padding-right: 15px;
  }
}
</style>
